import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import GmapVue from 'gmap-vue'
import { components as GmapComponents } from 'gmap-vue'
import VueGoogleCharts from 'vue-google-charts'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import VueOffline from 'vue-offline'
import numeral from 'numeral'
import wb from "./registerSW";
import fullscreen from 'vue-fullscreen'
// import { VueReCaptcha } from 'vue-recaptcha-v3'
//   Vue.use(VueReCaptcha, { 
//     siteKey: "6LeElr0aAAAAAAYR94wbhaLuTxPs9RsDo1PLRjL8",
//     loaderOptions: {
//       autoHideBadge: true,
//       // explicitRenderParameters: {
//       //   badge: 'bottomleft'
//       // }
//     }
//   });
import mLongPress from './directives/m-long-press'
import VueInputAutowidth from 'vue-input-autowidth'
import visibility from 'vue-visibility-change';

Vue.use(VueInputAutowidth)

Vue.use(mLongPress, { duration: 3000 });

Vue.use(fullscreen);

Vue.prototype.$workbox = wb;

Vue.use(VueOffline);

Vue.use(visibility);

Vue.use(vueNumeralFilterInstaller, { locale: 'pt-br' });
numeral.register('locale', 'pt-br-m', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'mil',
    million: 'mi',
    billion: 'bi',
    trillion: 'tri'
  },
  ordinal: function (number) {
    return 'º';
  },
  currency: {
    symbol: 'R$'
  }
});
numeral.locale('pt-br-m');

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyDrv2zpws8ugNtCZw8YTIz4O7d0VGpnPYA',
    libraries: 'places,visualization,drawing',
    region: 'BR',
    language: 'pt-BR'
  },
  installComponents: true
});
const { Cluster } = GmapComponents;
Vue.component('GmapCluster', Cluster)

Vue.use(VueGoogleCharts)

Vue.use(Croppa, { componentName: 'cropper' });

const moment = require('moment')
require('moment/locale/pt-br')

// Vue.use(require('vue-moment'), {
//     moment
// });

Vue.config.productionTip = false

// Vue.mixin({
//   beforeCreate() {
//     if (this.$options.watch) {
//       Object.entries(this.$options.watch).forEach(([watcherKey, func]) => {
//         this.$options.watch[watcherKey] = new Proxy(func, {
//           apply(target, thisArg) {
//             console.log(`Called watcher ${target.name} on component ${thisArg.$options.name}`);
//           },
//         });
//       });
//     }
//   },
// });

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
